import { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';

import LoadingComponent from '../LoadingComponent';
import RibbonTagComponent from '../RibbonTagComponent';
import CompleteIcon from './CompleteIcon.jsx';
import Text from '../Text';
import { imgOnError } from '../helpers';
import { htmlSanitizer } from '../../lib/helpers';

const TileComponent = ({
  draggable,
  tileContainerClass,
  id,
  loading,
  tileThumbnailClass,
  tileThumblinkOnClick,
  ignored,
  embedVideo,
  thumbnail,
  ribbonTagName,
  ribbonTagColor,
  date,
  calendarClass,
  calendarIcon,
  headline,
  audienceColor,
  shadowOverlayButtons,
  popdownMenu,
  copyButtonDisplay,
  user,
  copyPath,
  copyTile,
}) => {
  const embedVideoRef = useRef();

  useLayoutEffect(() => {
    if (embedVideoRef.current) {
      embedVideoRef.current.firstElementChild.tabIndex = -1;
    }
  });

  const thumbnailClass = () => {
    if (!embedVideo) return 'tile_thumbnail_image';

    return 'tile_thumbnail_image video_thumbnail';
  };

  return (
    <div
      className={
        draggable ? '' : `tile_container ${tileContainerClass} tile_width`
      }
      data-tile-container-id={id}
      disabled={loading}
      style={loading ? { pointerEvents: 'none' } : {}}
    >
      <div
        className={`tile_thumbnail ${tileThumbnailClass}`}
        id={`single-tile-${id}`}
      >
        {tileThumbnailClass === 'completed' && <CompleteIcon />}
        <TileContainer
          data-tile-id={id}
          onClick={tileThumblinkOnClick}
          className="tile-wrapper"
        >
          {tileThumbnailClass === 'completed' && <CompleteOverlay />}
          <div
            className={thumbnailClass()}
            style={ignored ? { opacity: '0.5' } : {}}
          >
            <img src={thumbnail} alt="" onError={imgOnError} />
            {ribbonTagName && (
              <RibbonTagComponent
                ribbonTagName={ribbonTagName}
                ribbonTagColor={ribbonTagColor}
                height="28"
              />
            )}
          </div>
          {date && (
            <div className={`activation_dates ${calendarClass}`}>
              <span className="tile-active-time">
                <i className={`fa-regular ${calendarIcon}`}></i>
                {date}
              </span>
            </div>
          )}
          <div className="headline">
            <Text
              as="p"
              m="0 8px 16px"
              variant="initials"
              color={
                tileThumbnailClass === 'completed' ? 'black.80' : 'black.100'
              }
              dangerouslySetInnerHTML={htmlSanitizer(headline)}
            />
          </div>
          {loading && (
            <div
              className="loading_overlay"
              style={{
                display: 'block',
                width: '100%',
                height: '100%',
                position: 'absolute',
                bottom: '0',
                left: '0',
                background: 'rgba(255, 255, 255, 0.92)',
                zIndex: '1',
              }}
            >
              <LoadingComponent />
            </div>
          )}
          <div
            style={{
              height: '3px',
              backgroundColor: audienceColor || '#fff',
            }}
          ></div>
          <div className="shadow_overlay">
            {shadowOverlayButtons && (
              <ul className="tile_buttons">{shadowOverlayButtons}</ul>
            )}
          </div>
          {popdownMenu && <div className="popdown-menu">{popdownMenu}</div>}
          <div className="tile_overlay"></div>

          {copyButtonDisplay && !(user.isGuestUser || user.isEndUser) && (
            <ul className="tile_buttons">
              <li className="explore_copy_button">
                <a
                  onClick={() => copyTile({ id, copyPath })}
                  className="button outlined explore_copy_link"
                  id={id}
                  data-tile-id={id}
                  data-section="Explore"
                >
                  <span className="explore_thumbnail_copy_text">Copy</span>
                </a>
              </li>
            </ul>
          )}
        </TileContainer>
      </div>
    </div>
  );
};

const TileContainer = styled.button`
  margin: 0;
  padding: 0;
  background: white;
  border: 0;
`;

const CompleteOverlay = styled.div`
  position: absolute;
  height: 192px;
  width: 255px;
  background: white;
  opacity: 0.3;
  z-index: 1;
`;

export default TileComponent;
